import { useTranslate } from "@tolgee/react";
import { sortBy } from "lodash-es";
import React from "react";
import { ItemSelect_ItemFragment } from "./ItemSelect.generated.js";
import { ButtonSelectMultiple } from "@msys/ui";

interface Props {
  itemIds: string[];
  onChange: (items: string[]) => void | Promise<void>;
  items: ItemSelect_ItemFragment[];
}

export const ButtonSelectItemsMultiple = ({
  itemIds,
  onChange,
  items,
}: Props) => {
  const { t } = useTranslate(["QuoteItem", "Global"]);
  const options = React.useMemo(
    () =>
      sortBy(items, i => i.pathSortable).map(i => ({
        value: i.id,
        label: `${i.pathForPdf} ${i.title}`.trim(),
      })),
    [items]
  );
  return (
    <ButtonSelectMultiple
      label={t("Items", { ns: "QuoteItem" })}
      searchLabel={t("Search", { ns: "Global" })}
      noOptionsLabel={t("There are no items to display", {
        ns: "Global",
      })}
      options={options}
      value={itemIds}
      onChange={onChange}
      popoverWidth="lg"
    />
  );
};
